import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { withStyles } from 'material-ui/styles';

import withAppStore from 'decorators/withAppStore';
import styles from 'styles/components/CodeInfoSection';
import CodeInfoSection from 'components/CodeInfoSection';
import Code from 'components/Code';
import ReturnToTree from 'components/ReturnToTree';

@withStyles(styles)
@withAppStore
@observer
export default class CodeInfoTree extends Component {

    render() {
        const { model } = this.props;
        return (
            <CodeInfoSection title='Классификация'
                table={{
                    headers: [
                        'Переход к дереву',
                        'Код',
                        'Описание'
                    ],
                    rows: model.tnved.map(({ id = 0, code = '', description = '', short_description }) => ([
                        <ReturnToTree id={id} code={code} tnved={model.tnved} />,
                        <Code code={code} />,
                        description + (id !== model.id ? ' ' + short_description : '')
                    ]))
                }}
            />
        );
    }
}





// WEBPACK FOOTER //
// ./src/components/codeinfo/CodeInfoTree.js